module.exports = __webpack_public_path__ + "assets/img/header-impressao.9b2a5593.png";